// custom history object to allow navigation outside react components
export const history: {navigate: any; location: any} = {
  navigate: null,
  location: null,
};
